'use strict';
/* global __DEBUG__:false, __WATCH__:false, __SHORTCUTS_ENABLED__:false */
/**
 * Import stylesheets
 */
import './../scss/main.scss';

import PIXI from 'expose-loader?PIXI!phaser-ce/build/custom/pixi.js';
import p2 from 'expose-loader?p2!phaser-ce/build/custom/p2.js';
import Phaser from 'expose-loader?Phaser!phaser-ce/build/custom/phaser-split.js';

import conf from './config';

import App from './App';
import Settings from 'utils/Settings';
import DeviceController from 'app/controller/DeviceController';

const checkExists = (lib, id) => {
  if (typeof lib === 'undefined') {
    console.error('Library Missing :\t', id);
  }
};

checkExists(PIXI, 'PIXI');
checkExists(p2, 'p2');
checkExists(Phaser, 'Phaser');

const deviceController = new DeviceController();

const shouldDisableWebAudio = deviceController.isOldAppleDevice();
window.PhaserGlobal = { disableWebAudio: shouldDisableWebAudio };

conf.settings = new Settings({});
conf.deviceController = deviceController;
conf.type = deviceController.getAppRenderTpye();

window.app = new App(conf);
